import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginActivateGuard } from './shared/guards/login-activate.guard';
import { LogoutActivateGuard } from './shared/guards/logout-activate.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./shared/components/tabs/tabs-routing.module').then(m => m.TabsPageRoutingModule),
    canActivate: [LoginActivateGuard]
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/components/login.page').then(
        (m) => m.LoginPage
      ),
    canActivate: [LogoutActivateGuard]
  },
  {
    path: 'register/:name/:email',
    loadComponent: () =>
      import('./pages/register/components/register.page').then(
        (m) => m.RegisterPage
      ),
    canActivate: [LogoutActivateGuard]
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./pages/register/components/register.page').then(
        (m) => m.RegisterPage
      ),
    canActivate: [LogoutActivateGuard]
  },
  { path: '', pathMatch: 'full', redirectTo: 'home/profile' },
  { path: '**', redirectTo: 'home/profile' }

];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
